import { features, stats, testimonials, faqs } from '@/mocks/content';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const scrollToDownload = () => {
    const el = document.getElementById('download');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20vibrant%20gradient%20abstract%20background%20with%20soft%20organic%20shapes%20in%20coral%20and%20teal%20tones%2C%20modern%20minimal%20design%2C%20youthful%20energy%2C%20smooth%20flowing%20curves%2C%20digital%20art%20style%2C%20bright%20and%20inviting%20atmosphere%2C%20no%20text%20or%20letters%2C%20clean%20aesthetic&width=1800&height=1200&seq=hero-chuniao-01&orientation=landscape"
            alt="雏鸟app社交成长平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading mb-5 leading-tight text-background-50">
              找到志同道合的伙伴
              <br />
              <span style={{ color: 'oklch(var(--primary-400))' }}>一起成长</span>
            </h1>
            <p className="text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed" style={{ color: 'oklch(var(--background-200))' }}>
              雏鸟app，专为年轻人打造的社交成长平台。智能兴趣匹配，多元内容分享，温暖社区互动，让你的每一次相遇都充满意义。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={scrollToDownload}
                className="px-8 py-3 rounded-full text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
                style={{ backgroundColor: 'oklch(var(--primary-500))', color: '#fff' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'oklch(var(--primary-600))';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'oklch(var(--primary-500))';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <i className="ri-download-line mr-2"></i>免费下载
              </button>
              <Link
                to="/category/feature-intro"
                className="px-8 py-3 rounded-full text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-200 border"
                style={{
                  borderColor: 'oklch(var(--background-200))',
                  color: 'oklch(var(--background-50))',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="w-full py-12 md:py-16" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {stats.map((stat, i) => (
                <div key={i} className="text-center p-6 rounded-lg" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                    <i className={`${stat.icon} text-2xl`} style={{ color: 'oklch(var(--primary-500))' }}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-heading mb-1" style={{ color: 'oklch(var(--foreground-950))' }}>{stat.value}</div>
                  <div className="text-sm" style={{ color: 'oklch(var(--foreground-600))' }}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="w-full py-16 md:py-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading mb-3" style={{ color: 'oklch(var(--foreground-950))' }}>
                核心功能
              </h2>
              <p className="text-sm md:text-base max-w-xl mx-auto" style={{ color: 'oklch(var(--foreground-600))' }}>
                六大核心功能，为你打造温暖而有深度的社交体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {features.map((feature) => {
                const colorVar = feature.color === 'primary' ? 'var(--primary-500)' : feature.color === 'accent' ? 'var(--accent-500)' : 'var(--secondary-500)';
                const bgVar = feature.color === 'primary' ? 'var(--primary-50)' : feature.color === 'accent' ? 'var(--accent-50)' : 'var(--secondary-50)';
                return (
                  <div
                    key={feature.id}
                    className="p-6 rounded-lg transition-all duration-200 cursor-pointer"
                    style={{ backgroundColor: 'oklch(var(--background-50))' }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <div
                      className="w-12 h-12 flex items-center justify-center rounded-lg mb-4"
                      style={{ backgroundColor: `oklch(${bgVar})` }}
                    >
                      <i className={`${feature.icon} text-xl`} style={{ color: `oklch(${colorVar})` }}></i>
                    </div>
                    <h3 className="text-base font-bold mb-2" style={{ color: 'oklch(var(--foreground-950))' }}>{feature.title}</h3>
                    <p className="text-sm leading-relaxed" style={{ color: 'oklch(var(--foreground-600))' }}>{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Download CTA Section */}
        <section id="download" className="w-full py-16 md:py-20 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20warm%20gradient%20abstract%20background%20with%20flowing%20curves%20in%20coral%20and%20amber%20tones%2C%20modern%20clean%20design%2C%20youthful%20vibrant%20energy%2C%20digital%20art%2C%20smooth%20organic%20shapes%2C%20minimal%20composition%2C%20no%20text&width=1800&height=900&seq=cta-chuniao-download&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>
          <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading mb-4 text-background-50">
              准备好开启你的社交新旅程了吗？
            </h2>
            <p className="text-sm md:text-base mb-8 max-w-lg mx-auto" style={{ color: 'oklch(var(--background-200))' }}>
              扫描二维码下载雏鸟app，或前往各大应用商店搜索「雏鸟」
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
              <div className="bg-background-50 rounded-lg p-3 w-36 h-36 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-qr-code-line text-5xl" style={{ color: 'oklch(var(--foreground-800))' }}></i>
                  <p className="text-xs mt-1" style={{ color: 'oklch(var(--foreground-600))' }}>扫码下载</p>
                </div>
              </div>
              <div className="flex flex-col gap-3">
                <a
                  href="#"
                  className="flex items-center gap-3 px-6 py-3 rounded-lg whitespace-nowrap cursor-pointer transition-all duration-200"
                  style={{ backgroundColor: 'oklch(var(--foreground-950))', color: '#fff' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'oklch(var(--foreground-800))';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'oklch(var(--foreground-950))';
                  }}
                >
                  <i className="ri-apple-fill text-xl"></i>
                  <div className="text-left">
                    <div className="text-xs">Download on the</div>
                    <div className="text-sm font-bold">App Store</div>
                  </div>
                </a>
                <a
                  href="#"
                  className="flex items-center gap-3 px-6 py-3 rounded-lg whitespace-nowrap cursor-pointer transition-all duration-200"
                  style={{ backgroundColor: 'oklch(var(--foreground-950))', color: '#fff' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'oklch(var(--foreground-800))';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'oklch(var(--foreground-950))';
                  }}
                >
                  <i className="ri-android-fill text-xl"></i>
                  <div className="text-left">
                    <div className="text-xs">Get it on</div>
                    <div className="text-sm font-bold">Google Play</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="w-full py-16 md:py-20" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading mb-3" style={{ color: 'oklch(var(--foreground-950))' }}>
                用户真实评价
              </h2>
              <p className="text-sm md:text-base max-w-xl mx-auto" style={{ color: 'oklch(var(--foreground-600))' }}>
                超过500万用户的选择，听听他们怎么说
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.slice(0, 3).map((t) => (
                <div
                  key={t.id}
                  className="p-5 rounded-lg"
                  style={{ backgroundColor: 'oklch(var(--background-100))' }}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                      width={40}
                      height={40}
                    />
                    <div>
                      <div className="text-sm font-bold" style={{ color: 'oklch(var(--foreground-950))' }}>{t.name}</div>
                      <div className="text-xs" style={{ color: 'oklch(var(--foreground-500))' }}>{t.role}</div>
                    </div>
                    <div className="ml-auto flex gap-0.5">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-star-fill text-xs" style={{ color: 'oklch(var(--secondary-500))' }}></i>
                        </div>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm leading-relaxed" style={{ color: 'oklch(var(--foreground-700))' }}>
                    {t.content}
                  </p>
                </div>
              ))}
            </div>
            <div className="text-center mt-8">
              <Link
                to="/about#testimonials"
                className="inline-flex items-center gap-1 text-sm font-medium whitespace-nowrap cursor-pointer"
                style={{ color: 'oklch(var(--primary-500))' }}
              >
                查看更多评价 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full py-16 md:py-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading mb-3" style={{ color: 'oklch(var(--foreground-950))' }}>
                常见问题
              </h2>
              <p className="text-sm" style={{ color: 'oklch(var(--foreground-600))' }}>
                快速了解雏鸟app，解答你的疑惑
              </p>
            </div>
            <div className="flex flex-col gap-3">
              {faqs.slice(0, 4).map((faq, i) => (
                <details
                  key={i}
                  className="group rounded-lg p-5 cursor-pointer"
                  style={{ backgroundColor: 'oklch(var(--background-50))' }}
                >
                  <summary className="flex items-center justify-between text-sm font-bold list-none" style={{ color: 'oklch(var(--foreground-950))' }}>
                    {faq.question}
                    <div className="w-5 h-5 flex items-center justify-center ml-3">
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                    </div>
                  </summary>
                  <p className="mt-3 text-sm leading-relaxed" style={{ color: 'oklch(var(--foreground-600))' }}>
                    {faq.answer}
                  </p>
                </details>
              ))}
            </div>
            <div className="text-center mt-6">
              <Link
                to="/category/faq"
                className="inline-flex items-center gap-1 text-sm font-medium whitespace-nowrap cursor-pointer"
                style={{ color: 'oklch(var(--primary-500))' }}
              >
                查看全部常见问题 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '雏鸟app官方介绍与下载指南',
            url: 'https://chuniao.app',
            description: '雏鸟app是专为年轻用户打造的社交成长平台，提供兴趣匹配、内容分享与社区互动功能。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://chuniao.app/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '雏鸟科技',
            url: 'https://chuniao.app',
            description: '专注于年轻人社交成长的科技公司',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'support@chuniao.app',
              contactType: 'customer service',
              availableLanguage: 'Chinese',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((f) => ({
              '@type': 'Question',
              name: f.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: f.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}